<template>
  <div class="wrapperBox">
    <div class="app-container">
      <div class="contentBox clearfix">
        <div class="logo">
          <div class="logo-left">
            <img :src="src" alt="logo" class="lh-logo" @click="goIndex()">
          <!--v-show="!imgSelect"-->
            <!--<img :src="src1" alt="logo" class="lh-logo2" @click="goIndex()" v-show="imgSelect">-->
          <div class="shu" v-show="headPart"></div>
          <h4 v-show="headPart" style="color: #525252">{{message}}</h4>
          </div>
          <div class="header-menu" @click="sign=!sign"><span></span> <span></span> <span></span></div>
        </div>
        <ul class="el-menu" v-show="sign">
          <li>
            <router-link to="/mainContainer" active-class="active-item">首页</router-link>
          </li>
          <li><a href="http://ipaiban.com/detail/fansnew.html" target="_blank">公众号涨粉</a></li>
          <li><a href="http://ipaiban.com/bianji.jsp" target="_blank">编辑器</a></li>
          <li>
            <router-link to="/helpCenter" active-class="active-item">帮助中心</router-link>
          </li>
          <li class="mr0">
            <el-button round style="border-color:#76a6f4;" @click="toHomePage">登 录</el-button>
          </li>
          <li class="mr0">
            <el-button round style="border-color:#76a6f4;" @click="toRegisterPage">注 册</el-button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderNav',
  data () {
    return {
      // src: './static/image/navBg1.png',
      src: './static/image/navBg2.png',
      src1: './static/image/logo.png',
      activeIndex: '1',
      message: '',
      headPart: false,
      imgSelect: false,
      sign: false
    }
  },
  created () {
    this.pathchange(this.$router.history.current)
  },
  methods: {
    goIndex () {
      this.$router.push({path: '/'})
    },
    toHomePage () {
      // location.href = 'http://lh.playhudong.com/#/login'
      window.open('http://lh.playhudong.com/#/login')
    },
    toRegisterPage () {
      window.open('https://lh.playhudong.com/#/register')
    },
    pathchange (newval) {
      if (newval.path.indexOf('helpCenter') > -1) {
        this.headPart = true
        this.message = '帮助中心'
        this.imgSelect = true
      } else if (newval.path.indexOf('agreement') > -1) {
        this.headPart = true
        this.message = '服务协议'
        this.imgSelect = true
      } else {
        this.headPart = false
        this.message = ''
        this.imgSelect = false
      }
      if (localStorage.getItem('ToggleDevice') === 'desktop') {
        this.sign = true
      }
      document.onresize = function () {
        if (localStorage.getItem('ToggleDevice') === 'desktop') {
          this.sign = true
        }
      }
    }
  //  cancleScoll(newval){
  //   var scrollTop=document.body.scrollTop||document.documentElement.scrollTop;
  //   var that=this;
  //   window.onscroll=function(e){
  //   if(newval&&localStorage.getItem('ToggleDevice')!=="desktop"){//判断是否已经打开了浮层
  //       that.sign=false;
  //   }
  //   }
  //  }
  },
  watch: {
    '$route': function (newval, oldval) {
      this.pathchange(newval)
    }
    // 'sign':function(newval,oldval){
    //  this.cancleScoll(newval)
    // }
  }
}
</script>
<style lang="less" scoped>
  .wrapperBox {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    transition: all .15s .05s;
    z-index: 2000;
    height: 80px;
    @media screen and (max-width: 768px){
      height: 50px;
    }
    .contentBox {
      height: 100%;
      position: relative;
      .el-menu{
        float: right;
        height: 100%;
        line-height: 80px;
        width: auto;
        border: none;
        @media screen and (max-width: 768px){
          float:none;
          // height: 100vh;
          // background: #fff
          border-bottom: 1px solid #eee;
          padding-bottom: 20px;
        }
        li {
          float: left;
          line-height: 80px;
          height: 80px;
          font-size: 14px;
          margin: 0 20px;
          letter-spacing: 1.8px;
          @media screen and (max-width: 768px){
          float:none;
          line-height: 50px;
          height: 50px;
          text-align: center;
          background: #fff;
          margin-right: 20px;
          border-bottom: 1px solid #f2f2f2
          }
          a {
            font-size: 14px;
          }
        }
        .active-item{
          color: #76a6f4;
        }
        .el-button span{
          color:#76a6f4 ! important;
        }
      }
      .logo {
        float: left;
        height: 80px;
        line-height: 80px;
        display: flex;
        align-items: center;
        @media (max-width: 768px){
          float: none;
          justify-content: space-between;
          padding: 0 20px;
          height: 50px;
          line-height: 50px;
        }
        img {
          vertical-align: middle;
        }
        .shu{
          background:#f0f1f3;
          width: 2px;
          height: 34px;
          margin: 0 10px;
          display: inline-block;
          vertical-align: middle;
        }
        h4{
          display: inline-block;
        }
        .header-menu{
        display:none;
          span{
            display: block;
            width: 20px;
            height: 1px;
            background-color: #3888ff;
          }
          span:nth-child(2){
            margin: 8px 0
          }
        }
        @media (max-width: 768px){
          .header-menu{
              position: relative;
              display: block;
              width: 20px;
              height: 20px;
              cursor: pointer;
              transition: all .5s;
          }
          span:first-child,span:nth-child(2){
            transform: translateY(0) rotate(0deg)
          }
          span:first-child{
            animation: outfirst .5s both
          }
        }
      }
    }
  }

  #app .el-menu-demo {
    border-bottom: none;
  }
  #app .el-button{
    color: #76a6f4;
    padding: 10px 23px;
  }
  #app .el-button:hover{
    background-color: #76a6f4;
    color: #fff;
  }
  .lh-logo{
  width: 140px;
  @media screen and (max-width: 768px) {
    width:100px;
  }
  }
  .lh-logo2{
    width: 65px;
  }
  .mr0{
    margin-right:0
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue